import React from 'react';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';

class ClinicShutdownForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      date: new Date(),
      reason: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleTextChange(event) {
    this.setState({ value: event.target.value });
  }

  handleReasonChange(event) {
    this.setState({ reason: event.target.value });
  }

  handleDateChange(date) {
    this.setState({ date: date });
  }

  handleSubmit(event) {
    event.preventDefault();
    const text = this.state.value;
    const date = this.state.date;
    const reason = this.state.reason;
    if (text !== '' && reason !== '') {
      this.props.onSubmit(date, text, reason);
      this.setState({ value: '', date: '', reason: '' });
    }
    else {
      toast.error('Please enter Hours & Reason.');
    }
  }

  render() {
    return (
      <form method="post" className="well padding-bottom-10" onSubmit={this.handleSubmit} >
        <div className="row form-group">
          <div className="col-md-3">
            <label className="control-label"><strong>Date: </strong></label><br/>
            <DatePicker className="form-control"
              selected={this.state.date}
              onChange={this.handleDateChange.bind(this)}
              placeholderText="Date"
              dateFormat="MM/dd/YYYY"
            />
          </div>
          <div className="col-md-3">
            <label className="control-label"><strong>Hours Missed: </strong></label>
            <input type="text" value={this.state.value} className="form-control" placeholder="Hours" onChange={this.handleTextChange.bind(this)} />
          </div>
          <div className="col-md-4">
            <label className="control-label"><strong>Reason: </strong></label>
            <input type="text" value={this.state.reason} className="form-control" placeholder="Reason" onChange={this.handleReasonChange.bind(this)} />
          </div>
          <div className="col-md-2">
            <br/>
            <button type="submit" className="btn btn-sm btn-primary pull-right">
              Save
					</button>
          </div>
        </div>
      </form>
    );
  }
}
export default ClinicShutdownForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/ClinicShutdownForm.js